import { Navigate, Route, Routes } from 'react-router-dom';

import * as routing from '../../../constants/Routing';
import { Project } from '../../../domain/project/Project';
import { DriversPOD } from '../pod';
import { DriversConfiguration } from './DriversConfiguration';
import { DriversStopFields } from './DriversStopFields';

interface DriversApplicationProps {
  project: Project;
}

export const DriversApplication = ({ project }: DriversApplicationProps) => {
  return (
    <Routes>
      <Route index element={<Navigate to={routing.DRIVERS.APP.STOP_FIELDS} />} />
      <Route path="/stop-fields" element={<DriversStopFields project={project} />} />
      <Route path="/pod/*" element={<DriversPOD project={project} />} />
      <Route path="/configuration" element={<DriversConfiguration project={project} />} />
      <Route path="*" element={<Navigate to={routing.DRIVERS.APP.CONFIGURATION} />} />
    </Routes>
  );
};
